import { render } from "./HobbysBarChart.vue?vue&type=template&id=b87e2102&scoped=true"
import script from "./HobbysBarChart.vue?vue&type=script&lang=js"
export * from "./HobbysBarChart.vue?vue&type=script&lang=js"

import "./HobbysBarChart.vue?vue&type=style&index=0&id=b87e2102&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b87e2102"]])

export default __exports__